import { ListingPictureKind } from '@kouto/types';
import { Listing } from 'types/listings';

export const getListingCoverPictures = (collection: Listing) => {
  return collection.pictures.filter(
    (picture) => picture.kind === ListingPictureKind.COVER,
  );
};
